"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = function (SQLite, options) { return __awaiter(_this, void 0, void 0, function () {
    var db, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                SQLite.DEBUG(options.debug || false);
                SQLite.enablePromise(true);
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, SQLite.openDatabase(__assign({ name: 'apipeline.db', location: 'default' }, (options.openDatabaseOptions || {})))];
            case 2:
                db = _a.sent();
                db.transaction(function (tx) {
                    tx.executeSql('CREATE TABLE IF NOT EXISTS cache (id TEXT PRIMARY KEY NOT NULL, value TEXT);');
                });
                return [2 /*return*/, {
                        getItem: getItem(db),
                        setItem: setItem(db),
                        removeItem: removeItem(db)
                    }];
            case 3:
                err_1 = _a.sent();
                throw new Error("APIPeline : Cannot open SQLite database : " + err_1 + ". Check your SQLite configuration.");
            case 4: return [2 /*return*/];
        }
    });
}); };
function getItem(db) {
    return function (key) {
        return new Promise(function (resolve, reject) {
            db.transaction(function (tx) {
                tx.executeSql('SELECT * FROM cache WHERE id=?', [key])
                    .then(function (res) {
                    var results = res[1];
                    var item = results.rows.item(0);
                    return resolve(item && item.value || null);
                })
                    .catch(function (err) {
                    return reject(err);
                });
            });
        });
    };
}
function setItem(db) {
    return function (key, value) {
        return new Promise(function (resolve, reject) {
            db.transaction(function (tx) {
                tx.executeSql('INSERT OR REPLACE INTO cache VALUES (?,?)', [key, value])
                    .then(function () {
                    return resolve();
                }).
                    catch(function (err) {
                    return reject(err);
                });
            });
        });
    };
}
function removeItem(db) {
    return function (key) {
        return new Promise(function (resolve, reject) {
            db.transaction(function (tx) {
                tx.executeSql('DELETE FROM cache WHERE id=?', [key])
                    .then(function () {
                    return resolve();
                })
                    .catch(function (err) {
                    return reject(err);
                });
            });
        });
    };
}
